import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="card p-8 text-center">
      <h1 className="mb-2 text-2xl font-semibold text-brand-text">Not found</h1>
      <p className="text-brand-muted">
        The page you're looking for doesn't exist.
      </p>
      <Link to="/applications" className="btn-secondary mt-6 inline-block py-2">
        Back to applications
      </Link>
    </div>
  );
}
